export enum OrderBlockedType {
  ALERT = "alert",
  WARNING = "warning",
}
